export const IS_CALCULATING = 'products/IS_CALCULATING';
export const IS_PREMIUM_ADJUSTING = 'products/IS_PREMIUM_ADJUSTING';
export const IS_SAVING = 'products/IS_SAVING';
export const IS_SAVING_FOR_EXIT = 'products/IS_SAVING_FOR_EXIT';
export const IS_ISSUING = 'products/IS_ISSUING';
export const SET_SOURCE = 'products/SET_SOURCE';
export const SET_REGIONS = 'products/SET_REGIONS';
export const SET_SCHEMES = 'products/SET_SCHEMES';
export const SET_SCHEMES_WITH_INCLUDES = 'products/SET_SCHEMES_WITH_INCLUDES';
export const SET_SIGNPOST = 'products/SET_SIGNPOST';
export const SET_QUOTE = 'products/SET_QUOTE';
export const SET_QUOTES = 'products/SET_QUOTES';
export const CLEAR_QUOTES = 'products/CLEAR_QUOTES';
export const SET_PRODUCT = 'products/SET_PRODUCT';
export const SET_PREMIUM_INDICATION = 'products/SET_PREMIUM_INDICATION';
export const IS_UPDATING_PREMIUM_INDICATION =
  'products/SET_IS_UPDATING_PREMIUM_INDICATION';
export const SET_NEXT_QUOTE_REFERENCE = 'products/SET_NEXT_QUOTE_REFERENCE';
export const SET_PREMIUM_OVERRIDE_CALCULATION =
  'products/SET_PREMIUM_OVERRIDE_CALCULATION';
export const SUBMIT_SUCCEEDED = 'products/SUBMIT_SUCCEEDED';
export const CLEAR_DATA = 'products/CLEAR_DATA';
export const SET_PREMIUM_INDICATION_ERROR = 'products/SET_PREMIUM_INDICATION_ERROR';
export const SANCTIONS_CHECK_IN_PROGRESS = 'products/SANCTIONS_CHECK_IN_PROGRESS';
export const SET_SANCTIONS = 'products/SET_SANCTIONS';
export const REMOVE_SANCTION = 'products/REMOVE_SANCTION';
export const SHOW_PAYMENT_IFRAME = 'products/SHOW_PAYMENT_IFRAME';

const initialState = {
  isCalculating: false,
  isPremiumAdjusting: false,
  isSaving: false,
  isSavingForExit: false,
  isIssuing: false,
  isUpdatingPremiumIndication: false,
  premiumIndication: {},
  premiumIndicationUpdatedAt: 0,
  premiumOverrideCalculation: {},
  premiumIndicationError: {},
  submitSucceeded: false,
  nextQuoteReference: '',
  policyForAdjustment: null,
  source: null,
  regions: [],
  schemes: [],
  quotes: null, // Objects as these are keyed by UUID
  resources: {}, // Objects as these are keyed by UUID
  // Sanctions
  sanctions: {},
  sanctionsCheckInProgress: false,
  totalSanctions: 0,
  signpost: null,
  paymentIframe: {
    show: false,
    transactionId: '',
  },
};

export default function productReducer(state = initialState, action) {
  switch (action.type) {
    case IS_CALCULATING:
      return {
        ...state,
        isCalculating: action.status,
      };
    case IS_PREMIUM_ADJUSTING:
      return {
        ...state,
        isPremiumAdjusting: action.status,
      };
    case IS_SAVING:
      return {
        ...state,
        isSaving: action.status,
      };
    case IS_SAVING_FOR_EXIT:
      return {
        ...state,
        isSavingForExit: action.status,
      };
    case IS_ISSUING:
      return {
        ...state,
        isIssuing: action.status,
      };
    case SUBMIT_SUCCEEDED:
      return {
        ...state,
        submitSucceeded: action.status,
      };
    case SET_SOURCE:
      return {
        ...state,
        source: action.data,
      };
    case SET_REGIONS:
      return {
        ...state,
        regions: action.data,
      };
    case SET_SCHEMES:
      return {
        ...state,
        schemes: action.data,
      };
    case SET_SCHEMES_WITH_INCLUDES:
      return {
        ...state,
        schemeIncludes: action.data,
      };
    case SET_SIGNPOST:
      return {
        ...state,
        signpost: action.data,
      };
    case SET_QUOTE:
      return {
        ...state,
        quotes: {
          ...state.quotes,
          [action.data.meta.scheme.id]: action.data,
        },
      };
    case SET_QUOTES:
      return {
        ...state,
        quotes: {
          ...action.data,
        },
      };

    case CLEAR_QUOTES:
      return {
        ...state,
        submitSucceeded: false,
        quotes: {},
      };
    case SET_PRODUCT:
      return {
        ...state,
        submitSucceeded: false,
        productId: action.data.data.id,
        resources: {
          ...state.resources,
          [action.data.data.id]: {
            ...action.data,
          },
        },
      };
    case IS_UPDATING_PREMIUM_INDICATION:
      return {
        ...state,
        isUpdatingPremiumIndication: action.status,
      };
    case SET_PREMIUM_INDICATION:
      return {
        ...state,
        premiumIndication: action.premium,
        premiumIndicationUpdatedAt: Date.now(),
      };
    case SET_NEXT_QUOTE_REFERENCE:
      return {
        ...state,
        submitSucceeded: false,
        nextQuoteReference: action.data,
      };
    case SET_PREMIUM_OVERRIDE_CALCULATION:
      return {
        ...state,
        premiumOverrideCalculation: action.data,
      };
    case SET_PREMIUM_INDICATION_ERROR:
      return {
        ...state,
        premiumIndicationError: action.data,
      };
    case CLEAR_DATA:
      return initialState;
    case SET_SANCTIONS:
      const totalSanctions = state.totalSanctions == null ? 0 : state.totalSanctions;
      return {
        ...state,
        sanctions: {
          ...state.sanctions,
          [action.key]: action.status,
        },
        totalSanctions: action.status ? totalSanctions + 1 : totalSanctions,
      };
    case REMOVE_SANCTION:
      const sanctions = state.sanctions;
      const newTotalSanctions = sanctions[action.key]
        ? state.totalSanctions - 1
        : state.totalSanctions;
      delete sanctions[action.key];

      return {
        ...state,
        sanctions,
        totalSanctions: newTotalSanctions,
      };
    case SANCTIONS_CHECK_IN_PROGRESS:
      return {
        ...state,
        sanctionsCheckInProgress: action.status,
        totalSanctions: action.status ? 0 : state.totalSanctions,
      };

    case SHOW_PAYMENT_IFRAME:
      return {
        ...state,
        paymentIframe: {
          show: action.data.show,
          transactionId: action.data.transactionId,
        },
      };
    default:
      return state;
  }
}
